import { useState, useEffect } from 'react';
import { Download, X, Share } from 'lucide-react';

export default function InstallAppPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIOS, setShowIOS] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem('pva_install_dismissed') === '1'; } catch { return false; }
  });

  useEffect(() => {
    // Already installed?
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) return;

    // Chrome / Android
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // iOS Safari (no beforeinstallprompt support)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isIOS && isSafari) setShowIOS(true);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
    }
  };

  const dismiss = () => {
    setDismissed(true);
    try { sessionStorage.setItem('pva_install_dismissed', '1'); } catch {}
  };

  if (dismissed) return null;
  if (!deferredPrompt && !showIOS) return null;

  return (
    <div
      data-testid="install-app-prompt"
      className="fixed bottom-20 right-3 sm:right-5 z-40 max-w-xs bg-gradient-to-br from-emerald-600 to-emerald-700 text-white rounded-xl shadow-2xl p-3 sm:p-4 animate-fade-up border border-emerald-400/30"
    >
      <button
        onClick={dismiss}
        className="absolute top-2 right-2 text-white/70 hover:text-white"
        aria-label="Cerrar"
        data-testid="install-dismiss-btn"
      >
        <X className="w-4 h-4" />
      </button>
      <div className="flex items-start gap-3 pr-5">
        <div className="bg-white/20 rounded-lg p-2 flex-shrink-0">
          <Download className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-sm">Instalar ParkingVision</p>
          {deferredPrompt ? (
            <>
              <p className="text-xs text-white/90 mt-0.5">Acceso directo desde tu pantalla principal, mas rapido y sin barras del navegador.</p>
              <button
                onClick={handleInstall}
                data-testid="install-app-btn"
                className="mt-2 bg-white text-emerald-700 font-bold text-xs px-3 py-1.5 rounded-full hover:bg-emerald-50 transition-colors"
              >
                Instalar ahora
              </button>
            </>
          ) : (
            <p className="text-xs text-white/90 mt-0.5 flex items-center gap-1 flex-wrap">
              Toca <Share className="w-3 h-3 inline" /> <strong>Compartir</strong> y luego <strong>"Anadir a pantalla inicio"</strong>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
